module.exports = __webpack_public_path__ + "img/kilometrosop.d46ed27e.png";